import { Area, AreaCreate, AreaDelete } from '@src/main/modules/common/area/domain/Area';
import { AreaRepository } from '@src/main/modules/common/area/domain/AreaRepository';
import { AreaResponse } from '@src/main/modules/common/area/infrastructure/AreaResponse';
import { TokenProvider, api } from '@src/main/modules/common/common/infrastructure/http/axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid';

export const createAreaHttpRepository = (tokenProvider: TokenProvider): AreaRepository =>
  new AreaHttpRepository(tokenProvider);

class AreaHttpRepository implements AreaRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  async findAll(): Promise<Area[]> {
    const token = await this.tokenProvider.getToken();
    const response = await api.get<AreaResponse[]>('/area', token);
    return response;
  }

  async put(area: AreaCreate): Promise<void> {
    const token = await this.tokenProvider.getToken();
    if (area.subsubareaId) {
      await api.put(`/area/${area.areaId}/${area.subareaId}/${area.subsubareaId}`, token, {
        name: area.name,
      });
    } else {
      await api.put(`/area/${area.areaId}/${area.subareaId}`, token, {
        name: area.name,
      });
      await api.put(`/area/${area.areaId}/${area.subareaId}/${uuidv4()}`, token, {
        name: 'Common',
      });
    }
  }

  async delete(area: AreaDelete): Promise<void> {
    const token = await this.tokenProvider.getToken();
    if (area.subsubareaId) {
      await api.delete(`/area/${area.areaId}/${area.subareaId}/${area.subsubareaId}`, token);
    } else {
      await api.delete(`/area/${area.areaId}/${area.subareaId}`, token);
    }
  }
}
